import * as React from 'react';
export var PreviewGroupContext = /*#__PURE__*/React.createContext(null);